export default "__VITE_ASSET__D7vFde2t__"